/**
 * Created by Alex Aguilar on 7/27/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('cities', {
                parent: 'app',
                url: '/cities',
                params: {
                    page: "0",
                    size: "10"
                },
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/configGeneral/adminAirport/city/cities.html',
                        controller: 'citiesController',
                        controllerAs: 'vm',
                        resolve:{
                            'tabs': ['tabService', function(tabService){
                                return tabService.getTabAdminAirports('cities')
                            }],
                            'cities': ['cityService','$stateParams', function(cityService,$stateParams){
                                return cityService.getPageCities($stateParams.page, $stateParams.size)
                            }],
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['city']);
                            }]
                        }
                    }
                }
            })
            .state('cityNew', {
                parent: 'app',
                url: '/city/new',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/configGeneral/adminAirport/city/newCity.html',
                            controller: 'newCityController',
                        controllerAs: 'vm',
                        resolve:{
                            'tabs': ['tabService', function(tabService){
                                return tabService.getTabAdminAirports('cities')
                            }],
                            'countries': ['countryService', function(countryService){
                                return countryService.getActiveCountries(true,false);
                            }],
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['city']);
                            }]
                        }
                    }
                }
            })
            .state('cityEdit', {
                parent: 'app',
                url: '/city/:id/edit',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/configGeneral/adminAirport/city/editCity.html',
                        controller: 'editCityController',
                        controllerAs: 'vm',
                        resolve: {
                            'tabs': ['tabService', function(tabService){
                                return tabService.getTabAdminAirports('cities')
                            }],
                            'countries': ['countryService', function(countryService){
                                return countryService.getActiveCountries(true,false);
                            }],
                            'city': ['cityService', '$stateParams', function(cityService, $stateParams) {
                                return cityService.getCity($stateParams.id)
                            }],
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['city']);
                            }]
                        }
                    }
                }
            })
            .state('cityDelete', {
                parent: 'cities',
                url: '/city/:id/delete',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/configGeneral/adminAirport/city/deleteCity.html',
                        controller: 'deleteCityController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            'city': ['cityService', function(cityService) {
                                return cityService.getCity($stateParams.id)
                            }],
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['city']);
                            }]
                        }
                    }).result.then(function() {
                        $state.go('cities', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    });
                }]
            });
    }
})();
